module.exports = __webpack_public_path__ + "img/bg-personal-square.c66f6ceb.webp";